import(/* webpackMode: "eager" */ "/app/apps/dtc-client/src/app/[lng]/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["OtScript"] */ "/app/apps/dtc-client/src/app/[lng]/OtScript.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/dtc-client/src/components/analytics/braze.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["AnalyticsProvider"] */ "/app/apps/dtc-client/src/components/analytics/provider.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/apps/dtc-client/src/components/datadog-connector.tsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/packages/ui-library/components/utils/providers/NotificationProvider.tsx");
